// import { OrderObjType } from '@/types';
import orderObjJson from '../json/session.json';
import { getQueryStringByName } from '@/utils/helper';
import { cloneDeep } from 'lodash';

const key = `${getQueryStringByName('wapid')}_orderObj`;
const getSessionValue = () => {
  const res = sessionStorage.getItem(key);
  if (!res) {
    sessionStorage.setItem(key, JSON.stringify(cloneDeep(orderObjJson)));
    return cloneDeep(orderObjJson);
  } else {
    try {
      return JSON.parse(res);
    } catch (e) {
      return cloneDeep(orderObjJson);
    }
  }
};

export const orderObj = (set, get) => {
  return {
    orderObj: getSessionValue(),
    setOrderObj: (next) => {
      set(() => ({
        orderObj: next,
      }));
      const { orderObj } = get();
      sessionStorage.setItem(key, JSON.stringify(orderObj));
    },
  };
};
